module.exports = __webpack_public_path__ + "img/img37.7ae4bebe.svg";